const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20jur%C3%ADdica';

const navLinks = [
  { label: 'Início', href: '#inicio' },
  { label: 'Sobre o Escritório', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer style={{ background: '#0B2F5B' }}>
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Col 1 – Branding */}
          <div>
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/35809de3bd8ca3e54d2132ab70a4ca98.png"
              alt="LC Advogados"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-sm leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Especialistas em recuperação de golpes bancários e crimes digitais em Franca/SP. Defendemos seus direitos com rigor e agilidade.
            </p>
            <address className="not-italic text-sm leading-loose" style={{ color: 'rgba(255,255,255,0.55)' }}>
              <p>Av. Paulo VI, 1986 – Residencial Paraíso</p>
              <p>Franca – SP, Brasil</p>
            </address>
          </div>

          {/* Col 2 – Nav */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase mb-6" style={{ color: '#C9A24A' }}>Navegação</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleAnchor(e, link.href)}
                    className="text-sm transition-colors duration-200 cursor-pointer hover:text-white"
                    style={{ color: 'rgba(255,255,255,0.65)' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 – Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase mb-6" style={{ color: '#C9A24A' }}>Fale Conosco</h4>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-bold text-sm mb-6 cursor-pointer whitespace-nowrap transition-all duration-300 hover:opacity-90"
              style={{ background: '#C9A24A', color: '#0B2F5B' }}
            >
              <i className="ri-whatsapp-line text-base" />
              Chamar no WhatsApp
            </a>

            <div className="space-y-3 mb-6">
              <a href="tel:+5516981106759" className="flex items-center gap-3 text-sm cursor-pointer hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.7)' }}>
                <i className="ri-phone-line text-base" style={{ color: '#C9A24A' }} />
                +55 (16) 98110-6759
              </a>
              <a href="mailto:lcadvogadosbr@gmail.com" className="flex items-center gap-3 text-sm cursor-pointer hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.7)' }}>
                <i className="ri-mail-line text-base" style={{ color: '#C9A24A' }} />
                lcadvogadosbr@gmail.com
              </a>
            </div>

            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://instagram.com/lc.advogadosbr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
                style={{ border: '1px solid rgba(201,162,74,0.4)', color: '#C9A24A' }}
                aria-label="Instagram LC Advogados"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
                style={{ border: '1px solid rgba(201,162,74,0.4)', color: '#C9A24A' }}
                aria-label="WhatsApp LC Advogados"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t" style={{ borderColor: 'rgba(201,162,74,0.2)' }}>
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.45)' }}>
            &copy; {new Date().getFullYear()} LC Advogados. Todos os direitos reservados.
          </p>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs hover:opacity-70 transition-opacity cursor-pointer"
            style={{ color: 'rgba(255,255,255,0.35)' }}
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
